import Gradient from 'chartjs-plugin-gradient';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { other } from '../../common/labelConstants';


// Note: changes to the plugin code is not reflected to the chart, because the plugin is loaded at chart construction time and editor changes only trigger an chart.update().
const image = new Image();
image.src = 'https://www.chartjs.org/img/chartjs-logo.svg';



ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend, Gradient);

const _props = {
    labels: [],
    datasets: [],
    totalDatasets: 0,
    graphConfig:{},
}

export function LineChart(props = _props) {
    const data = {
        labels: props.labels.map((label) => (typeof label==='object')?other:label),
        datasets: [{
            fill: true,
            label: props.graphConfig.label,
            data: props.datasets,
            borderColor: props.graphConfig.borderColor,
            gradient: {
                backgroundColor: {
                    axis: 'y',
                    colors: {
                        100: props.graphConfig.color,
                        0: '#ffffff1a'
                    }
                }
            },
            borderWidth:2,
            pointBackgroundColor:"#fff",
            pointRadius:4.3,
            pointHoverRadius:5,
            borderCapStyle: 'butt',
            borderDash: [],
        }]
    };
   
    return <div className='row align-item-center mt-3 line-chart'>
    <div className='col-md-12'>
        <Line options={{
            
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        boxWidth: 22,
                        boxHeight: 4
                    },
                    onHover:(e)=>{
                        e.native.target.style.cursor = 'pointer';
                    },
                    onLeave:(e)=>{
                        e.native.target.style.cursor = 'default';
                    },

                },
                datalabels: {
                    borderColor: 'white',
                    borderRadius: 25,
                    borderWidth: 0,
                    color: 'white',
                    display: function (context) {
                        var dataset = context.dataset;
                        var count = dataset.data.length;
                        var value = dataset.data[context.dataIndex];
                        return value > count * 1.5;
                    },
                    font: {
                        weight: 'bold'
                    },
                    padding: 2,
                    formatter: (val) => {
                        return ''
                    }
                }
            },
            onHover:(e,activeEls)=>{
                e.native.target.style.cursor = activeEls[0] ? 'pointer':'';
              },
            scales: {
                x: {
                    grid: {
                        display: false
                    },
                    offset: true
                },
                y: {
                    grid: {
                        borderDash: [4],
                        display: true,
                        drawTicks:false,
                        lineWidth:[1.3]
                    }
                }
            },
            // Core options
            responsive: true,
            aspectRatio: 8 / 3.6,
            layout: {
                padding: 6
            }
            
        }

        } data={data} />
        </div>
    </div>
}
